skrilla.filter('minutesBreakdown', function() {
    return function(string ) {
        const minutes = parseInt(string)
        if (!minutes) {
         return null;
        }

        let days = Math.trunc(minutes / (60 * 24));
        let hours = Math.trunc((minutes % (60 * 24)) / (60));

        if (days  && hours) return  `(${days } days | ${hours} hours)`;
        if (days) return  `(${days} days)`;
        if (hours) return  `(${hours} hours)`;
    };
})
